// extracted by mini-css-extract-plugin
module.exports = {"content":"PromotionsPromos_content___4Lig"};